export function initialize() {
    $('[data-filter="area"]').each(function() {
        var area = $(this);
        var filter = area.find('[data-filter="form"]');
        var items = area.find('[data-filter="items"]');

        var links = filter.find('a');
        var input = filter.find('input');

        links.on('click', function(e) {
            e.preventDefault();

            input.val('');

            var link = $(this);
            var id = link.attr('id');

            links.removeClass('active');
            link.addClass('active');

            if (id === 'all') {
                $('[data-filter-group]').show();
            } else {
                $('[data-filter-group]').hide();
                $('[data-filter-group*="' + id + '"]').show();
            }
        });

        input.on('keyup', function() {
            links.removeClass('active');

            var input = $(this);
            var value = input.val().toLowerCase();

            if(value.length < 1) {
                $('[data-filter-name]').show();
            } else {
                $('[data-filter-name]').hide();
                $('[data-filter-name*="' + value + '"]').show();
            }
        });
    });
}

export default {};
